import * as qs from 'qs';
import {clearProducts} from '../store/actions/options';
import {API} from './API';

export class ProductService {
  async getTableProducts(params, additional = {}) {
    const [query, page, length] = API.getTableParams(params, additional);
    return this.getProducts(query, page, length);
  }

  async getProducts(query, page, length) {
    return (await API.getConnection())
      .get('products', {
        params: {...query, ...{page, length}},
        paramsSerializer: params => qs.stringify(params),
      })
      .then(response => response.data)
      .catch(error => API.handleError(error));
  }

  async getSummaries(location) {
    return (await API.getConnection())
      .get('products/summaries', {
        params: {location: location.id},
        paramsSerializer: params => qs.stringify(params),
      })
      .then(response => response.data['summaries'])
      .catch(error => API.handleError(error));
  }

  async getProduct(id, archive = false) {
    return (await API.getConnection())
      .get(`products/${id}`, {
        params: archive ? {filter: {archive: 'only'}} : {},
        paramsSerializer: params => qs.stringify(params),
      })
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async saveProduct(product) {
    let data = product;
    let method = 'post';
    let url = 'products';
    if (product.id) {
      method = 'put';
      url = `products/${product.id}`;
    }
    return (await API.getConnection())
      [method](url, data)
      .then(response => {
        API.store.dispatch(clearProducts());
        return response.data.data;
      })
      .catch(error => API.handleError(error));
  }

  async getAssociations(product) {
    return (await API.getConnection())
      .get(`products/${product.id}/associations`)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async associate(product, associateID) {
    return (await API.getConnection())
      .put(`products/${product.id}/associations`, {product_id: associateID})
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async deleteProduct(id) {
    return (await API.getConnection())
      .delete(`products/${id}`)
      .then(response => {
        API.store.dispatch(clearProducts());
        return response;
      })
      .catch(error => API.handleError(error));
  }

  async restoreProduct(id) {
    return (await API.getConnection())
      .put(`products/${id}/restore`)
      .then(response => {
        API.store.dispatch(clearProducts());
        return response.data.data;
      })
      .catch(error => API.handleError(error));
  }

  async reorderCertificationDetails(product, details) {
    return (await API.getConnection())
      .put(`products/${product.id}/certification-details`, {details})
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async saveCertificationDetail(product, detail) {
    let data = detail;
    let method = 'post';
    let url = `products/${product.id}/certification-details`;
    if (detail.id) {
      method = 'put';
      url = `${url}/${detail.id}`;
    }
    return (await API.getConnection())
      [method](url, data)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async deleteCertificationDetail(product, detail) {
    return (await API.getConnection())
      .delete(`products/${product.id}/certification-details/${detail.id}`)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }
}
